import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { propStr } from '../../../../helpers/custom-prop-types';
import SlideSearchVerticalTitleIcon from '../../../Icon/Svg/SlideSearchVerticalTitleIcon';
const SlideSearchCircleLink = (props) => {
    const { className } = props;
    return (_jsx(Link, Object.assign({ className: clsx('slide_search_circle_link', className), to: '/proffit_search' }, { children: _jsxs("div", Object.assign({ className: 'button_inner' }, { children: [_jsx(SlideSearchVerticalTitleIcon, { className: 'button_svg' }), _jsx("div", Object.assign({ className: 'button_text' }, { children: "\u30B9\u30E9\u30A4\u30C9\u691C\u7D22" }))] })) })));
};
SlideSearchCircleLink.propTypes = {
    className: propStr(),
};
SlideSearchCircleLink.defaultProps = {
    className: '',
};
export default SlideSearchCircleLink;
